import { useConfiguredFormContext } from '../contexts';
import { useObservable } from './useObservable';

export const useFormValues = () =>
  useObservable(useConfiguredFormContext().fb.values$, {});
